import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Routing from './routes/Routing';
import { useAppInsightsPageTracking } from '../hooks/useAppInsightsPageTracking';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/nl';

import NavMain from './components/navigation/NavMain';
import NavHeader from './components/navigation/NavHeader';
import NavFooter from './components/navigation/NavFooter';
import NavSitemap from './components/navigation/NavSitemap';
import TermsAcknowledgementDialog from './components/authorization/TermsAcknowledgementDialog';
import SystemNoticesGate from './components/systemNotices/SystemNoticesGate';

import { setGlobalNavigate } from './services/utils/navigation';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  useAppInsightsPageTracking();

  const noFooterPathParts = [
    "/settings",
    "/dashboard",
    "/plannen"
  ];
  
  const hideFooter = noFooterPathParts.some((pathPart) =>
    location.pathname.startsWith(pathPart)
  );
  
  const showFooter = !hideFooter;

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  // useEffect(() => {
  //   // const log = () => console.log('Scroll Y:', window.scrollY);
  //   // window.addEventListener('scroll', log);
  //   // return () => window.removeEventListener('scroll', log);
  // }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="nl">
      <div className="app">
        <NavMain />
        <NavHeader />
        <Routing />
        {showFooter && (
          <>
            <NavSitemap />
            <NavFooter />
          </>
        )}
      </div>
      <TermsAcknowledgementDialog />
      <SystemNoticesGate />
    </LocalizationProvider>
  );
}

export default App;
